import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Seo from "../components/Seo";
import "../components/booth/tokens.css";
import BoothMark from "../components/booth/BoothMark";
import Footer from "../components/booth/Footer";
import "./Unsubscribe.css";

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://thebooth.gg"
    : "http://localhost:8000";

function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("form"); // "form", "submitting", "success", "error"
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setErrorMessage("Invalid unsubscribe link");
    }
  }, [searchParams]);

  const handleUnsubscribe = async (event) => {
    event.preventDefault();

    if (!confirmed) {
      setErrorMessage("Please confirm that you no longer want emails from The Booth");
      return;
    }

    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setErrorMessage("Invalid unsubscribe link");
      return;
    }

    setErrorMessage("");
    setStatus("submitting");

    try {
      await axios.post(`${API_BASE_URL}/unsubscribe`, { params: { token } });
      setStatus("success");
    } catch (error) {
      setStatus("error");
      setErrorMessage(
        error.response?.data?.error ||
          (typeof error.response?.data === "string" ? error.response?.data : null) ||
          "Unsubscribe failed. Please try again."
      );
    }
  };

  const renderContent = () => {
    switch (status) {
      case "form":
      case "submitting":
        return (
          <>
            <p className="booth-auth-eyebrow">Step inside</p>
            <h1 className="booth-auth-title">Unsubscribe from The Booth</h1>
            <p className="booth-unsubscribe-dek">
              We're sorry to see you go. Confirm below to stop receiving emails
              from The Booth.
            </p>
            <form onSubmit={handleUnsubscribe} className="booth-auth-form" noValidate>
              <label className="booth-checkbox">
                <input
                  type="checkbox"
                  checked={confirmed}
                  onChange={(e) => setConfirmed(e.target.checked)}
                />
                I no longer want to receive emails from The Booth
              </label>
              {errorMessage && (
                <span className="booth-field-error">{errorMessage}</span>
              )}
              <button
                type="submit"
                className="booth-btn booth-btn--primary booth-auth-submit"
                disabled={status === "submitting"}
              >
                {status === "submitting" ? "Unsubscribing…" : "Confirm unsubscribe"}
              </button>
            </form>
          </>
        );

      case "success":
        return (
          <>
            <h1 className="booth-auth-title">You're unsubscribed.</h1>
            <p className="booth-unsubscribe-dek">
              You won't receive any more emails from The Booth.
            </p>
            <button
              type="button"
              className="booth-btn booth-btn--primary booth-auth-submit"
              onClick={() => navigate("/")}
            >
              Return home <span aria-hidden="true">→</span>
            </button>
          </>
        );

      case "error":
        return (
          <>
            <h1 className="booth-auth-title">We couldn't unsubscribe you.</h1>
            <p className="booth-unsubscribe-dek">{errorMessage}</p>
            <button
              type="button"
              className="booth-btn booth-btn--primary booth-auth-submit"
              onClick={() => navigate("/")}
            >
              Return home <span aria-hidden="true">→</span>
            </button>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="booth booth-unsubscribe-page">
      <Seo
        title="Unsubscribe — The Booth"
        description="Stop receiving weekly dispatch emails from The Booth."
        path="/unsubscribe"
        noindex
      />
      <header className="booth-shell booth-unsubscribe-masthead">
        <a
          href="/"
          className="booth-unsubscribe-mark-link"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <BoothMark />
        </a>
      </header>
      <main className="booth-shell booth-unsubscribe-main">
        <div className="booth-auth-card">{renderContent()}</div>
      </main>
      <Footer />
    </div>
  );
}

export default Unsubscribe;
